<template>
  <!-- 过渡动画容器 核心是vue2的transition + div实现 -->
  <transition :name="animateName">
    <div
      class="animate-box-container"
      v-show="visible"
      :style="getContainerStyle()"
    >
      <!-- 插槽：放入需要加动画的内容（搜索框/任意内容） -->
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  name: "AnimateBox",
  props: {
    // 是否显示（控制动画：显示=进入动画，隐藏=离开动画）必传
    visible: {
      type: Boolean,
      default: true,
    },
    // 动画类型（提供4种常用过渡动画，够用99%场景）
    animateType: {
      type: String,
      default: "fade", // fade=淡入淡出  slide=左右滑入滑出  scale=缩放  top=上下划入划出
      validator: (val) => ["fade", "slide", "scale", "top"].includes(val),
    },
    // 动画过渡时长(毫秒)，可动态传参，适配不同场景
    duration: {
      type: Number,
      default: 300,
    },
    // 自定义容器样式（可选，和你搜索组件的getStyle写法保持一致）
    customStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // 对应不同动画类型的类名
    animateName() {
      return `ani-${this.animateType}`;
    },
  },
  methods: {
    // 统一管理动态样式，和你之前要求的getStyle写法一致，规范统一
    getContainerStyle() {
      const baseStyle = {
        transitionDuration: `${this.duration}ms`,
        width: "100%",
        boxSizing: "border-box",
      };
      // 合并自定义样式
      return { ...baseStyle, ...this.customStyle };
    },
  },
};
</script>

<style scoped lang="scss">
// 动画容器基础样式
.animate-box-container {
  width: 100%;
  box-sizing: border-box;
}

// ========== 1. 淡入淡出动画 (默认) ==========
.ani-fade-enter-active,
.ani-fade-leave-active {
  transition: all v-bind(duration) ms ease;
}
.ani-fade-enter,
.ani-fade-leave-to {
  opacity: 0;
}

// ========== 2. 左右滑动动画 ==========
.ani-slide-enter-active,
.ani-slide-leave-active {
  transition: all v-bind(duration) ms ease;
}
.ani-slide-enter,
.ani-slide-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}

// ========== 3. 缩放动画 ==========
.ani-scale-enter-active,
.ani-scale-leave-active {
  transition: all v-bind(duration) ms ease-out;
}
.ani-scale-enter,
.ani-scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

// ========== 4. 上下划入划出动画 ==========
.ani-top-enter-active,
.ani-top-leave-active {
  transition: all v-bind(duration) ms ease;
}
.ani-top-enter,
.ani-top-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}
</style>
